export const ROUTE_PATHS = {
  HOME: '/',
  JOBS: '/jobs',
  JOB_DETAIL: '/jobs/:id',
  FOR_EMPLOYERS: '/for-employers',
  ABOUT: '/about',
} as const;

export interface Company {
  id: string;
  name: string;
  logo: string;
  description: string;
  industry: string;
  size: string;
  location: string;
  website?: string;
  founded?: string;
}

export interface Job {
  id: string;
  title: string;
  company: Company;
  location: string;
  type: 'full-time' | 'part-time' | 'contract' | 'internship';
  category: JobCategory;
  salary: {
    min: number;
    max: number;
    currency: string;
  };
  description: string;
  requirements: string[];
  responsibilities: string[];
  benefits: string[];
  tags: string[];
  postedAt: string;
  deadline?: string;
  views?: number;
  applicants?: number;
  featured?: boolean;
}

export type JobCategory =
  | 'technology'
  | 'design'
  | 'marketing'
  | 'sales'
  | 'finance'
  | 'operations'
  | 'hr'
  | 'customer-service'
  | 'engineering'
  | 'product';

export const jobCategories = [
  { value: 'technology', label: '技术开发' },
  { value: 'design', label: '设计' },
  { value: 'marketing', label: '市场营销' },
  { value: 'sales', label: '销售' },
  { value: 'finance', label: '财务' },
  { value: 'operations', label: '运营' },
  { value: 'hr', label: '人力资源' },
  { value: 'customer-service', label: '客户服务' },
  { value: 'engineering', label: '工程' },
  { value: 'product', label: '产品' },
] as const;

export const locations = [
  '北京',
  '上海',
  '深圳',
  '广州',
  '杭州',
  '成都',
  '南京',
  '武汉',
  '西安',
  '苏州',
  '远程',
] as const;

export const salaryRanges = [
  { value: '0-10', label: '10K以下' },
  { value: '10-20', label: '10K-20K' },
  { value: '20-30', label: '20K-30K' },
  { value: '30-50', label: '30K-50K' },
  { value: '50-100', label: '50K-100K' },
  { value: '100+', label: '100K以上' },
] as const;
